import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=13b98e2e&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=13b98e2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b98e2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13b98e2e')) {
      api.createRecord('13b98e2e', component.options)
    } else {
      api.reload('13b98e2e', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=13b98e2e&scoped=true&", function () {
      api.rerender('13b98e2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24CwhT4Hl8rws/JS/teamMember.vue"
export default component.exports